"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jssha_1 = (0, tslib_1.__importDefault)(require("jssha"));
function default_1(text, session) {
    if (!session)
        return {};
    const { publicKey, secretKey } = session;
    if (!publicKey || !secretKey)
        return {};
    const shaObj = new jssha_1.default('SHA-512', 'TEXT');
    shaObj.setHMACKey(secretKey, 'TEXT');
    shaObj.update(text);
    const signature = shaObj.getHMAC('HEX');
    return signature;
}
exports.default = default_1;
